exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box .title[data-v-7b2d9537]{cursor:pointer}", ""]);

// exports
